import { ref } from 'vue';

export const pageLoading = ref(true);
